module.exports = __webpack_public_path__ + "img/story2.c01804b4.png";